<template>
  <div id="portal-article-edit">
    <div class="labelTitle lable title-area">
      <span v-if="type == 1">お知らせ 記事編集</span>
      <span v-if="type == 2">ご案内 記事編集</span>
      <span v-if="type == 3">学会・イベント情報 記事編集</span>
      <span v-if="type == 4">ニュース 記事編集</span>
      <span v-if="type == 5">製品情報 記事編集</span>
    </div>
    <div class="button-area">
      <b-button
        v-if="type == 1"
        class="backButton is-primary"
        @click="goToPortalSettingFrom(1)"
        >戻る</b-button
      >
      <b-button
        v-if="type == 2"
        class="backButton is-primary"
        @click="goToPortalSettingFrom(2)"
        >戻る</b-button
      >
      <b-button
        v-if="type == 3"
        class="backButton is-primary"
        @click="goToPortalSettingFrom(3)"
        >戻る</b-button
      >
      <b-button
        v-if="type == 4"
        class="backButton is-primary"
        @click="goToPortalSettingFrom(4)"
        >戻る</b-button
      >
      <b-button
        v-if="type == 5"
        class="backButton is-primary"
        @click="goToPortalSettingFrom(5)"
        >戻る</b-button
      >
    </div>
    <div class="content-area">
      <table>
        <tr>
          <td class="content-area-td-title require">タイトル</td>
          <td>
            <input v-model="title" type="text" maxlength="50" />
          </td>
        </tr>
        <tr v-if="type == 4">
          <td class="content-area-td-title require">タイトルリンクURL</td>
          <td>
            <input v-model="titleLinkUrl" type="text" maxlength="1000" />
          </td>
        </tr>
        <tr v-if="type == 1">
          <td class="content-area-td-title require">本文</td>
          <td>
            <textarea
              v-model="content"
              class="noresize"
              style="width: 100%"
              rows="5"
              maxlength="500"
            ></textarea>
          </td>
        </tr>
        <tr v-if="type == 2 || type == 5">
          <td class="content-area-td-title require">分類</td>
          <td>
            <select v-model="categoryValue" @change="filterProductList()">
              <option v-if="!categoryValue"></option>
              <option
                v-for="category in portalCategoryList"
                :key="category.optionValue"
                :value="category.optionValue"
              >
                {{ category.optionName }}
              </option>
            </select>
          </td>
        </tr>
        <tr v-if="type == 2">
          <td class="content-area-td-title require">製品名</td>
          <td>
            <select v-model="productValue" size="4" multiple>
              <option v-if="!categoryValue" value="" style="color: #696969">
                選択された分類によって対象の製品名が表示されます。「Ctrl」キーを押しながら選択することで複数選択が可能です。
              </option>
              <option
                v-for="product in filteredProductList"
                :key="product.optionValue"
                :value="product.optionValue"
              >
                {{ product.optionName }}
              </option>
            </select>
          </td>
        </tr>
        <tr v-if="type == 5">
          <td class="content-area-td-title require">製品名</td>
          <td>
            <select v-model="productValue[0]">
              <option></option>
              <option
                v-for="product in filteredProductList"
                :key="product.optionValue"
                :value="product.optionValue"
              >
                {{ product.optionName }}
              </option>
            </select>
          </td>
        </tr>
        <tr v-if="type == 5">
          <td class="content-area-td-title require">対象者</td>
          <td>
            <select v-model="targetValue">
              <option></option>
              <option
                v-for="target in portalTargetAudienceList"
                :key="target.optionValue"
                :value="target.optionValue"
              >
                {{ target.optionName }}
              </option>
            </select>
          </td>
        </tr>
        <tr v-if="type == 3 || type == 4">
          <td class="content-area-td-title">画像アップロード</td>
          <td v-if="!articleId">
            <input
              id="imgFileUp"
              @change="uploadImageFile"
              type="file"
              accept=".png, .jpeg, .jpg"
              style="width: 95%"
            />
            <a
              style="vertical-align: middle; margin-left: auto"
              v-if="imgDelIcon"
              @click="imgClearIcon()"
              ><b-icon icon="delete-forever-outline"
            /></a>
          </td>
          <td v-if="articleId">
            <input
              id="imgFileUp"
              @change="uploadImageFile"
              ref="inputImg"
              type="file"
              style="width: 95%; display: none"
              accept=".png, .jpeg, .jpg"
            /><button @click="inputImgBtnclick">ファイルを差し替える</button>
            {{ setImgFileName }}
            <a
              style="vertical-align: middle; margin-left: auto"
              v-if="imgDelIcon"
              @click="imgClearIcon()"
              ><b-icon icon="delete-forever-outline"
            /></a>
          </td>
        </tr>
        <tr v-if="(type == 3 || type == 4) && imageFileUrl && articleId">
          <td class="content-area-td-title"></td>
          <td>
            <div>
              <a @click="downloadFile(imageFileUrl)"></a>
              {{ imageFileName }}
            </div>
          </td>
        </tr>
        <tr v-if="type == 2 || type == 3">
          <td class="content-area-td-title require">PDFアップロード</td>
          <td v-if="!articleId">
            <input
              id="pdfFileUp"
              @change="uploadPdfFile"
              type="file"
              accept=".pdf"
              style="width: 95%"
            />
            <a
              v-if="pdfDelIcon"
              style="vertical-align: middle; margin: 0 0 0 auto"
              @click="pdfClearIcon()"
              ><b-icon icon="delete-forever-outline"
            /></a>
          </td>
          <td v-if="articleId">
            <input
              id="pdfFileUp"
              @change="uploadPdfFile"
              ref="inputPdf"
              type="file"
              style="width: 95%; display: none"
              accept=".pdf"
            /><button @click="inputPdfBtnclick">ファイルを差し替える</button>
            {{ setPdfFileName }}
            <a
              style="vertical-align: middle; margin-left: auto"
              v-if="pdfDelIcon"
              @click="pdfClearIcon()"
              ><b-icon icon="delete-forever-outline"
            /></a>
          </td>
        </tr>
        <tr
          v-if="
            (type == 2 && pdfFileUrl && articleId) ||
            (type == 3 && pdfFileUrl && articleId)
          "
        >
          <td class="content-area-td-title"></td>
          <td>
            <div>
              <a @click="downloadFile(pdfFileUrl)"
                ><b-icon icon="clipboard-arrow-right-outline"
              /></a>
              {{ pdfFileName }}
            </div>
          </td>
        </tr>
        <tr v-if="type == 5">
          <td class="content-area-td-title">PDFアップロード</td>
          <td v-if="!articleId">
            <input
              id="pdfFileUp"
              @change="uploadPdfFile"
              type="file"
              style="width: 95%"
              accept=".pdf"
              :disabled="articleId && type == 5 && externalLinkUrl"
            />
            <a
              style="vertical-align: middle; margin: 0 0 0 auto"
              v-if="pdfDelIcon"
              @click="pdfClearIcon()"
              ><b-icon icon="delete-forever-outline"
            /></a>
          </td>
          <td v-if="articleId">
            <input
              id="pdfFileUp"
              @change="uploadPdfFile"
              ref="inputPdf"
              type="file"
              style="width: 95%; display: none"
              accept=".pdf"
              :disabled="articleId && type == 5 && externalLinkUrl"
            /><button
              @click="inputPdfBtnclick"
              :disabled="articleId && type == 5 && externalLinkUrl"
            >
              ファイルを差し替える
            </button>
            {{ setPdfFileName }}
            <a
              style="vertical-align: middle; margin-left: auto"
              v-if="pdfDelIcon"
              @click="pdfClearIcon()"
              ><b-icon icon="delete-forever-outline"
            /></a>
          </td>
        </tr>
        <tr v-if="type == 5 && pdfFileUrl && articleId">
          <td class="content-area-td-title"></td>
          <td>
            <div>
              <a @click="downloadFile(pdfFileUrl)"
                ><b-icon icon="clipboard-arrow-right-outline"
              /></a>
              {{ pdfFileName }}
            </div>
          </td>
        </tr>
        <tr v-if="type == 3 || type == 5">
          <td class="content-area-td-title">関連サイトURL</td>
          <td>
            <input
              v-model="externalLinkUrl"
              type="text"
              maxlength="1000"
              :disabled="articleId && type == 5 && pdfFileUrl"
            />
          </td>
        </tr>
        <tr v-if="type == 3">
          <td class="content-area-td-title">備考</td>
          <td>
            <input v-model="remarks" type="text" maxlength="50" />
          </td>
        </tr>
      </table>
    </div>
    <div class="button-area">
      <b-button v-if="!articleId" class="is-primary" @click="save(type)"
        >保存する</b-button
      >
      <b-button v-if="articleId" class="is-primary" @click="update(type)"
        >更新する</b-button
      >
      <b-button class="is-primary" @click="del()">削除する</b-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type: "",
      data: "",
      articleTypeCode: "",
      articleId: "",
      classificationCode: "",
      classificationName: "",
      content: "",
      createdAt: "",
      externalLinkUrl: "",
      imageFileName: "",
      imageFileUrl: "",
      pdfFileUrl: "",
      productCodes: "",
      productNames: "",
      remarks: "",
      targetAudienceCode: "",
      targetAudienceName: "",
      title: "",
      titleLinkUrl: "",
      name: "",
      pdfFileName: "",
      setPdfFileName: "",
      setImgFileName: "",
      caseCheck: "",
      categoryValue: "",
      portalCategoryList: [],
      productValue: [],
      filteredProductList: [],
      portalProductList: [],
      targetValue: "",
      portalTargetAudienceList: [],
      imgDelIcon: false,
      pdfDelIcon: false,
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    goToPortalSettingFrom(type) {
      this.$router.push({ path: "/philips/portal-setting?type=" + type });
    },
    async initialize() {
      this.type = this.$route.query.type;
      this.articleId = this.$route.query.articleId;
      await this.loadPortalSelectBoxItems();
      await this.loadPortalArticle();
    },
    // //選択肢リスト取得
    loadPortalSelectBoxItems() {
      const THIS = this;
      return this.apiCall(
        function (client) {
          return client.apis.portalSetting.loadPortalSelectBoxItems();
        },
        function (result) {
          THIS.portalCategoryList = result.obj.classificationSelectItemList;
          THIS.portalProductList = result.obj.productSelectItemList;
          THIS.portalTargetAudienceList =
            result.obj.targetAudienceSelectItemList;
        },
        function (error) {
          console.log(error);
        }
      );
    },
    // ポータル設定画面　掲載記事取得
    loadPortalArticle() {
      const THIS = this;
      if (!this.articleId) {
        return;
      }
      let requestArticleId = {
        article_id: this.articleId,
      };
      return this.apiCall(
        function (client) {
          return client.apis.portalSetting.loadPortalArticle(requestArticleId);
        },
        function (success) {
          THIS.title = success.obj.title;
          THIS.titleLinkUrl = success.obj.titleLinkUrl;
          THIS.content = success.obj.content;
          THIS.categoryValue = success.obj.classificationCode;
          THIS.filterProductList();
          if (success.obj.productCodes) {
            THIS.productValue = success.obj.productCodes.split(",");
          }
          THIS.targetValue = success.obj.targetAudienceCode;
          if (success.obj.imageFileName) {
            THIS.imageFileName = success.obj.imageFileName;
          }
          THIS.imageFileUrl = success.obj.imageFileUrl;
          THIS.pdfFileUrl = success.obj.pdfFileUrl;
          if (success.obj.pdfFileName) {
            THIS.pdfFileName = success.obj.pdfFileName;
          }
          THIS.externalLinkUrl = success.obj.externalLinkUrl;
          THIS.remarks = success.obj.remarks;
        },
        function (error) {
          console.log(error);
        }
      );
    },
    //分類による製品名フィルター
    filterProductList() {
      this.productValue = [];
      this.filteredProductList = this.portalProductList.filter((v) => {
        return v.optionParentValue == this.categoryValue;
      });
    },
    //掲載記事の保存
    save(type) {
      var appVue = this.$root.$children[0];
      if (this.title && this.content && type == 1) {
        this.caseCheck = "10";
      } else if (
        this.title &&
        this.categoryValue &&
        this.productValue.length &&
        this.pdfFile &&
        type == 2
      ) {
        this.caseCheck = "10";
      } else if (this.title && this.pdfFile && type == 3) {
        this.caseCheck = "10";
      } else if (this.title && this.titleLinkUrl && type == 4) {
        this.caseCheck = "10";
      } else if (
        this.title &&
        this.categoryValue &&
        this.productValue.length &&
        this.targetValue &&
        type == 5
      ) {
        if (
          (this.pdfFile && this.externalLinkUrl) ||
          (!this.pdfFile && !this.externalLinkUrl)
        ) {
          this.caseCheck = "21";
        } else {
          this.caseCheck = "10";
        }
      } else {
        this.caseCheck = "20";
      }
      const THIS = this;
      switch (this.caseCheck) {
        case "10":
          this.$dialog.confirm({
            title: "新規掲載記事",
            message: "この記事を保存します。",
            cancelText: "キャンセル",
            onConfirm: async () => {
              appVue.loadingStart();
              let params = {
                articleTypeCode: THIS.$route.query.type,
                title: THIS.title,
              };
              if (THIS.type == 1) {
                params.content = THIS.content;
              }
              if (THIS.type == 2) {
                params.classificationCode = THIS.categoryValue;
                params.productCodes = THIS.productValue;
                params.pdfFile = THIS.pdfFile;
                params.pdfFileName = THIS.pdfFile.name;
              }
              if (THIS.type == 3) {
                if (THIS.imageFile) {
                  params.imageFile = THIS.imageFile;
                  params.imageFileName = THIS.imageFile.name;
                }
                params.pdfFile = THIS.pdfFile;
                params.pdfFileName = THIS.pdfFile.name;
                params.externalLinkUrl = THIS.externalLinkUrl;
                if (THIS.remarks) {
                  params.remarks = THIS.remarks;
                }
              }
              if (THIS.type == 4) {
                params.titleLinkUrl = THIS.titleLinkUrl;
                if (THIS.imageFile) {
                  params.imageFile = THIS.imageFile;
                  params.imageFileName = THIS.imageFile.name;
                }
              }
              if (THIS.type == 5) {
                params.classificationCode = THIS.categoryValue;
                params.productCodes = THIS.productValue;
                params.targetAudienceCode = THIS.targetValue;
                if (THIS.pdfFile) {
                  params.pdfFile = THIS.pdfFile;
                  params.pdfFileName = THIS.pdfFile.name;
                }
                if (THIS.externalLinkUrl) {
                  params.externalLinkUrl = THIS.externalLinkUrl;
                }
              }
              return THIS.callApi(
                false,
                function (client) {
                  return client.apis.portalSetting.createPortalArticle(params);
                },
                function (result) {
                  appVue.loadingEnd();
                  THIS.showSuccess(result, function () {
                    //前画面に戻る
                    THIS.goToPortalSettingFrom(THIS.type);
                  });
                },
                function (error) {
                  appVue.loadingEnd();
                  THIS.showErrorMessage(error);
                }
              );
            },
          });
          break;
        case "20":
          this.$dialog.alert({
            title: "入力エラー",
            message: "必須項目が入力されていません。",
          });
          break;
        case "21":
          this.$dialog.alert({
            title: "入力エラー",
            message:
              "PDFと関連サイトへのリンクはどちらか一方を入力してください。",
          });
          break;
        default:
          break;
      }
    },
    //掲載記事の更新
    update(type) {
      var appVue = this.$root.$children[0];
      if (this.title && this.content && type == 1) {
        this.caseCheck = "11";
      } else if (
        this.title &&
        this.categoryValue &&
        this.productValue.length &&
        type == 2
      ) {
        this.caseCheck = "11";
      } else if (this.title && type == 3) {
        this.caseCheck = "11";
      } else if (this.title && this.titleLinkUrl && type == 4) {
        this.caseCheck = "11";
      } else if (
        this.title &&
        this.categoryValue &&
        this.productValue.length &&
        this.targetValue &&
        type == 5
      ) {
        if (
          (this.pdfFileUrl && this.externalLinkUrl) ||
          (!this.pdfFileUrl && !this.externalLinkUrl)
        ) {
          this.caseCheck = "21";
        } else {
          this.caseCheck = "11";
        }
      } else {
        this.caseCheck = "20";
      }
      const THIS = this;
      switch (this.caseCheck) {
        case "11":
          this.$dialog.confirm({
            title: "既存掲載記事",
            message: "この記事を更新します。",
            cancelText: "キャンセル",
            onConfirm: async () => {
              appVue.loadingStart();
              let params = {
                articleId: THIS.$route.query.articleId,
                title: THIS.title,
              };
              if (THIS.type == 1) {
                params.content = THIS.content;
              }
              if (THIS.type == 2) {
                params.classificationCode = THIS.categoryValue;
                params.productCodes = THIS.productValue;
                if (THIS.pdfFile) {
                  params.pdfFile = THIS.pdfFile;
                  params.pdfFileName = THIS.pdfFile.name;
                }
              }
              if (THIS.type == 3) {
                if (THIS.imageFile) {
                  params.imageFile = THIS.imageFile;
                  params.imageFileName = THIS.imageFile.name;
                }
                if (THIS.pdfFile) {
                  params.pdfFile = THIS.pdfFile;
                  params.pdfFileName = THIS.pdfFile.name;
                }
                params.externalLinkUrl = THIS.externalLinkUrl;
                params.remarks = THIS.remarks;
              }
              if (THIS.type == 4) {
                params.titleLinkUrl = THIS.titleLinkUrl;
                if (THIS.imageFile) {
                  params.imageFile = THIS.imageFile;
                  params.imageFileName = THIS.imageFile.name;
                }
              }
              if (THIS.type == 5) {
                params.classificationCode = THIS.categoryValue;
                params.productCodes = THIS.productValue;
                params.targetAudienceCode = THIS.targetValue;
                if (THIS.targetValue) {
                  params.targetAudienceCode = THIS.targetValue;
                }
                if (THIS.pdfFile) {
                  params.pdfFile = THIS.pdfFile;
                  params.pdfFileName = THIS.pdfFile.name;
                }
                if (THIS.externalLinkUrl) {
                  params.externalLinkUrl = THIS.externalLinkUrl;
                }
              }
              return this.callApi(
                false,
                function (client) {
                  return client.apis.portalSetting.updatePortalArticle(params);
                },
                function (result) {
                  appVue.loadingEnd();
                  THIS.showSuccess(result, function () {
                    //前画面に戻る
                    THIS.goToPortalSettingFrom(THIS.type);
                  });
                },
                function (error) {
                  appVue.loadingEnd();
                  THIS.showErrorMessage(error);
                }
              );
            },
          });
          break;
        case "20":
          this.$dialog.alert({
            title: "入力エラー",
            message: "必須項目が入力されていません。",
          });
          break;
        case "21":
          this.$dialog.alert({
            title: "入力エラー",
            message:
              "PDFと関連サイトへのリンクはどちらか一方を入力してください。",
          });
          break;
        default:
          break;
      }
    },
    //掲載記事削除
    del() {
      var THIS = this;
      this.$dialog.confirm({
        title: "掲載記事削除",
        message: "この記事を削除します。",
        cancelText: "キャンセル",
        onConfirm: async () => {
          return this.apiCall(
            function (client) {
              return client.apis.portalSetting.deletePortalArticle({
                body: { articleId: THIS.articleId },
              });
            },
            function (result) {
              console.log("success", result.obj);
              THIS.showSuccess(result, THIS.goToPortalSettingFrom(THIS.type));
            },
            function (error) {
              console.log(error);
              THIS.showErrorMessage(error);
            }
          );
        },
      });
    },
    //掲載記事更新
    //image
    uploadImageFile(e) {
      this.imageFile = e.target.files[0];
      let element = document.getElementById("imgFileUp").files[0];
      if (element) {
        this.setImgFileName = element.name;
      }
      this.imgDelIcon = true;
    },
    //
    uploadPdfFile(e) {
      this.pdfFile = e.target.files[0];
      let element = document.getElementById("pdfFileUp").files[0];
      if (element) {
        this.setPdfFileName = element.name;
      }
      this.pdfDelIcon = true;
    },
    downloadFile(fileAddress) {
      this.apiCall(
        function (client) {
          return client.apis.apiCommon.getDownloadFilePOST({
            body: {
              fileId: 0,
              fileName: fileAddress,
            },
          });
        },
        function (result) {
          var downloadUrl = result.obj.downloadUrl;
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.href = downloadUrl;
          a.target = "_blank";
          a.click();
          a.remove();
        },
        function (error) {
          console.log("file download failed.", error);
        }
      );
    },
    //ファイルクリア
    pdfClearIcon() {
      this.pdfFile = "";
      pdfFileUp.value = "";
      this.setPdfFileName = "";
    },
    imgClearIcon() {
      this.imageFile = "";
      imgFileUp.value = "";
      this.setImgFileName = "";
    },
    inputPdfBtnclick() {
      this.$refs.inputPdf.click();
    },
    inputImgBtnclick() {
      this.$refs.inputImg.click();
    },
  },
};
</script>
<style scoped>
#portal-article-edit {
  width: 75%;
  margin: 20px auto;
}
.title-area {
  margin-bottom: 20px;
}
.content-area {
  padding: 10px;
  border: 1px solid;
  border-radius: 5px;
}
.content-area-td-title {
  width: 220px;
}
.image-file {
  object-fit: contain;
  min-width: 160px;
  max-height: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/portal/PortalArticleEdit.vue